import type { TPendingMediaAnalysis } from './collectPendingMediaAnalyses';

export const groupMediaIdsByJob = (analyses: TPendingMediaAnalysis[]): Record<string, string[]> =>
  analyses.reduce<Record<string, string[]>>((groups, { jobId, mediaId }) => {
    const mediaIds = groups[jobId] ?? [];
    return mediaIds.includes(mediaId) ? groups : { ...groups, [jobId]: [...mediaIds, mediaId].sort() };
  }, {});
